import { render } from "./font_awesome.vue?vue&type=template&id=22c0f61e&scoped=true"
import script from "./font_awesome.vue?vue&type=script&lang=js"
export * from "./font_awesome.vue?vue&type=script&lang=js"

import "./font_awesome.vue?vue&type=style&index=0&id=22c0f61e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c0f61e"]])

export default __exports__